module.exports = __webpack_public_path__ + "static/media/building-onwr.042ef00c.png";